<template>
  <div id="Kontakte" class="pb-2">
    <AppNavbar />

    <div v-if="benutzer && benutzer.funktionen.kommunikation == 1">
      <KontakteHeader />

      <b-container>
        <b-row>
          <b-col>
            <b-button v-b-modal.kontaktAnlegen variant="warning" class="mx-2 mb-5 float-right"><font-awesome-icon icon="plus"/> Neuer Kontakt</b-button>
          </b-col>
        </b-row>
      </b-container>

      <div v-if="kontakteStatus.getBenutzerKontakte" class="text-center mt-5">
        <b-spinner variant="warning" type="grow"></b-spinner>
      </div>

      <b-container v-else>
        <b-row v-if="kontakte.length === 0 && kontakteStatus.errMsg">
          <b-col>
            <b-alert variant="danger" show>{{kontakteStatus.errMsg}}</b-alert>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col cols="12" sm="6" lg="4" v-for="kontakt in kontakte" :key="kontakt.id" class="mb-4">
            <KontaktCard :kontakt="kontakt" />
          </b-col>
        </b-row>
        
      </b-container>

      <!-- Kontakt hinzufügen  Modal -->
      <b-modal id="kontaktAnlegen" title="Neuen Kontakt hinzufügen" size="lg" header-bg-variant="warning" header-text-variant="white" hide-footer>
        <KontaktNeuAnlegen @creatContactToast="makeToast"/>
      </b-modal>
    </div>

    <b-container v-else class=" py-5 headSpace">
      <b-alert variant="danger" class="mt-4" show>Diese Seite steht dir nicht zur Verfügung</b-alert>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppNavbar from '@/components/Nav/AppNavbar'
import KontakteHeader from '../Content/KommunikationHeader'
import KontaktCard from '../Content/KontaktCard'
import KontaktNeuAnlegen from '../Content/KontaktNeuAnlegen'

export default {
  name: 'kontakte',
  components: {
    KontaktCard,
    KontaktNeuAnlegen,
    AppNavbar,
    KontakteHeader
  },
  methods: {
    ...mapActions(['getBenutzerKontakte']),
    makeToast (toast) {
      this.$bvToast.toast(toast.msg, {
        title: toast.title,
        toaster: 'b-toaster-bottom-full',
        variant: toast.variant,
        autoHideDelay: 7000,
        appendToast: true,
        solid: true
      })
    }
  },
  computed: mapGetters(['benutzer', 'kontakte', 'kontakteStatus']),
  mounted () {
    if (!this.kontakte || this.kontakte.length === 0) {
      this.getBenutzerKontakte()
        .then(() => {
          if (this.kontakteStatus.errMsg) {
            const toast = {
              title: '',
              msg: this.kontakteStatus.errMsg,
              variant: 'danger'
            }

            this.makeToast(toast)
          }
        })
    }
  }
}
</script>

<style scoped>
.headSpace {
  margin-top: 6em;
}
</style>
